import { useBranch } from "@/context/branch-context";

/** Name of a branch by its BiteBerry uuid (pizza/order documents) or its admin id. */
export const useBranchName = (branchId: string | null | undefined) => {
  const { branches } = useBranch();
  if (!branchId) return null;
  return (
    branches?.find((branch) => branch.bb_branch_id === branchId || branch.id === branchId)
      ?.name ?? null
  );
};
